<template lang="html">
  <b-form @submit="onSubmit" class="col-lg-9 col-page-content page-style-2">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Publicar nueva vacante</h4>
              <hr />
            </div>

            <b-form-group class="col-lg-12 custom-f-group-1" label="Título del Puesto*" label-for="i-1">
              <b-form-input
                id="i-1"
                v-model="form.nombre"
                type="text"
                placeholder="Ventas de Mostrador"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-lg-12 custom-f-group-1" label="Descripción de la vacante*" label-for="i-2">
              <editor
                  v-model="form.descripcion"
                 api-key="voyk5grgw5zv5ueomjptgwscn9vyw7a0sifs0oy5fxj4befk"
                 :init="{
                   height: 265,
                   menubar: false,
                   language: 'es_MX',
                   paste_block_drop: false,
                   paste_as_text: !0,
                   entity_encoding: 'raw',
                   plugins: [
                     'advlist autolink lists link image charmap print preview anchor',
                     'searchreplace visualblocks code fullscreen',
                     'insertdatetime media table paste code help wordcount'
                   ],
                   toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignleft aligncenter alignright alignjustify | \
                     bullist numlist outdent indent | removeformat'
                 }"
              />
            </b-form-group>

            <b-form-group class="col-lg-12 custom-f-group-1" label="Ofrecemos" label-for="i-2">
              <editor
                  v-model="form.ofrecemos"
                 api-key="voyk5grgw5zv5ueomjptgwscn9vyw7a0sifs0oy5fxj4befk"
                 :init="{
                   height: 265,
                   menubar: false,
                   language: 'es_MX',
                   paste_block_drop: false,
                   paste_as_text: !0,
                   entity_encoding: 'raw',
                   plugins: [
                     'advlist autolink lists link image charmap print preview anchor',
                     'searchreplace visualblocks code fullscreen',
                     'insertdatetime media table paste code help wordcount'
                   ],
                   toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignleft aligncenter alignright alignjustify | \
                     bullist numlist outdent indent | removeformat'
                 }"
              />
            </b-form-group>

            <b-form-group class="col-md-6 col-xl-4 custom-f-group-1" label="Tipo de trabajo*" label-for="i-3">
              <b-form-select id="i-3" required v-model="form.tipo_puesto">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option value="tiempo_completo">Tiempo completo</b-form-select-option>
                <b-form-select-option value="medio_completo">Medio tiempo</b-form-select-option>
                <b-form-select-option value="temporal">Temporal</b-form-select-option>
                <b-form-select-option value="freelance">Freelance</b-form-select-option>
                <b-form-select-option value="home_office">Home office</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 col-xl-4 custom-f-group-1" label="Sector del Empleo*" label-for="i-4">
              <b-form-select id="i-4" required v-model="form.areas_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option :value="are.id" v-for="are in areasOpcs" :key="are.id">{{are.nombre}}</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <!-- <b-form-group class="col-md-6 col-xl-4 custom-f-group-1" label="Fecha limite para aplicar*" label-for="i-5">
              <b-form-select id="i-5" required v-model="form.fechalimite">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option value="a">Ninguna</b-form-select-option>
                <b-form-select-option value="b">30 días</b-form-select-option>
              </b-form-select>
            </b-form-group> -->
            <b-form-group class="col-md-6 col-xl-4 custom-f-group-1">
              <label for="i-5" class="d-block" label-for="i-5">Fecha limite para aplicar*</label>
              <b-form-input
                id="i-5"
                v-model="form.aplicar_antesde"
                type="date"
                
                required
              ></b-form-input>
            </b-form-group>

            <!-- <b-form-group class="col-12 custom-f-group-1">
              <label for="i-6" class="d-block" label-for="i-6">Habilidades indispensables* <small>(separado por comas)</small></label>
              <b-form-input
                id="i-6"
                v-model="form.habilidades"
                type="text"
                placeholder="Manejo de Office, Manejo de Adobe"
                required
              ></b-form-input>
            </b-form-group> -->

            <b-form-group class="col-12 custom-f-group-1" label="Habilidades indispensables*" label-for="i-6">
                <b-form-group
               
                label-for="i-6">
                <v-select v-model="form.habilidades" :options="habilidadesOpcs" label="nombre" index="id" multiple/>
              </b-form-group>
            </b-form-group>



            <b-form-group class="col-md-4 custom-f-group-1">
              <label for="i-6" class="d-block" label-for="i-6">Periodo de Sueldo*</label>
              <b-form-select required v-model="form.periodo">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option value="diario">Diario</b-form-select-option>
                <b-form-select-option value="semanal">Semanal</b-form-select-option>
                <b-form-select-option value="quincenal">Quincenal</b-form-select-option>
                <b-form-select-option value="mensual">Mensual</b-form-select-option>
                <b-form-select-option value="anual">Anual</b-form-select-option>
                <b-form-select-option value="por_proyeto">Por proyeto</b-form-select-option>
                
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-4 col-xl-4 custom-f-group-1">
              <label for="i-7" class="d-block" label-for="i-7">Sueldo Ofrecido*</label>
               <currency-input id="i-7"
                v-model="form.sueldo"
                placeholder="$ 0.00"
                required 
                class="form-control" />

              <!-- <b-form-input
                id="i-7"
                v-model="form.sueldo"
                type="text"
                placeholder="$ 0.00"
                required
              ></b-form-input> -->
            </b-form-group>

            <b-form-group class="col-md-4 custom-f-group-1">
              <label for="i-6" class="d-block" label-for="i-6">Regular/Urgente</label>
              <b-form-select required v-model="form.urgente_regular">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option value="urgente">Urgente</b-form-select-option>
                <b-form-select-option value="regular">Regular</b-form-select-option>
                
                
              </b-form-select>
            </b-form-group>


            <!--b-form-group class="col-md-4 custom-f-group-1">
              <b-form-input
                v-model="form.sueldomax"
                type="text"
                placeholder="$ Max."
                required
              ></b-form-input>
            </b-form-group-->

          </div>
        </div>

        <div class="mt-4 box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Otros requisitos</h4>
              <hr />
            </div>

            <b-form-group class="col-md-6 custom-f-group-1" label="Nivel de estudio" label-for="i-7">
              <b-form-select id="i-7" v-model="form.nivel_estudios">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option value="ninguno">Ninguno</b-form-select-option>
                <b-form-select-option value="preescolar">Preescolar</b-form-select-option>
                <b-form-select-option value="primaria">Primaria</b-form-select-option>
                <b-form-select-option value="secundaria">Secundaria</b-form-select-option>
                <b-form-select-option value="tecnica">Tecnica</b-form-select-option>
                <b-form-select-option value="preparatoria">Preparatoria</b-form-select-option>
                <b-form-select-option value="profesional">Profesional</b-form-select-option>
                <b-form-select-option value="maestria_doctorado">Maestria o doctorado</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Experiencia" label-for="i-8">
              <b-form-input id="i-8"
                v-model="form.experiencia"
                type="text"
                placeholder=""
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Género*" label-for="i-9">
              <b-form-select id="i-9" required v-model="form.genero">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option value="masculino">Masculino</b-form-select-option>
                <b-form-select-option value="femenino">Femenino</b-form-select-option>
                <b-form-select-option value="ambos">Ambos</b-form-select-option>
                <b-form-select-option value="indistinto">Indistinto</b-form-select-option>

              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Requisito especial" label-for="i-10">
              <b-form-input
                id="i-10"
                v-model="form.requisito_especial"
                type="text"
                placeholder=""
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <div class="mt-4 box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Domicilio de trabajo</h4>
              <hr />
            </div>

            <b-form-group class="col-md-12 custom-f-group-1" label="Dirección completa*" label-for="i-11">
              <b-form-input
                id="i-11"
                v-model="form.direccion"
                type="text"
                placeholder="Calle, número, colonia"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Estado*" label-for="i-10">
              <b-form-select id="i-10" required v-model="form.estado_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option :value="state.id" v-for="state in statesOpcs" :key="state.id">{{state.name}}</b-form-select-option>
              </b-form-select>
            </b-form-group>

            <b-form-group class="col-md-6 custom-f-group-1" label="Ciudad*" label-for="i-11">
              <b-form-select id="i-11" required v-model="form.ciudad_id">
                <b-form-select-option :value="null" disabled>Seleccione una opción</b-form-select-option>
                <b-form-select-option :value="town.id" v-for="town in townsOpcs" :key="town.id">{{town.name}}</b-form-select-option>
              </b-form-select>
            </b-form-group>

          </div>
        </div>

        <div class="mt-2 px-0 box-empty-bubble">
          <b-form-checkbox
            class="mb-3 custom-checkbox-s1"
            v-model="form.check"
            name="checkbox-1"
            value="accepted"
            unchecked-value="not_accepted"
            required>
            Al hacer clic en la casilla de verificación, acepta nuestros <a @click="openedModal = 'terminos'" href="#">Términos y condiciones</a> y <a href="#" @click="openedModal = 'aviso'">Política de privacidad</a>
          </b-form-checkbox>

          <b-button type="submit" class="btn-HelvNeu btn-squ-cur-1 btn-send">Crear vacante</b-button>
        </div>
      </div>
      <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
      </sweet-modal>
      <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
      </sweet-modal>
      <!-- Modal aviso de privacidad-->
    <modalaviso-component></modalaviso-component>
    <!--  -->

    <!-- Modal terminos-->
        <modalterminos-component></modalterminos-component>
        <!--  -->

    </div>
  </b-form>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import modalavisoComponent from '../modals/modal-aviso-privacy.vue';
import modalterminosComponent  from '../modals/modal-terminos.vue';
export default {
  data(){
    return{
      id:null,
      form: {
        
        tipo_puesto:null,
        areas_id:null,
        tipo_sueldo:null,
        periodo:null,
        genero:null,
        nivel_estudios:null,
        estado_id:null,
        ciudad_id:null,
        urgente_regular:null,
        check:'not_accepted',
      },
      areasOpcs:[],
      statesOpcs:[],
      townsOpcs:[],

      habilidadesOpcs:[],
      modal:{
          icon:null,
          msg:null
      },
       openedModal: null,
    }
  },
  watch:{
      'form.estado_id':function(val){
          this.getTownsOpcs(val);
      },      
  },
  methods: {
      getData(){
        axios.get(tools.url("/api/admin/vacancies/"+this.id))
        .then((response)=>{
              this.form = response.data;
            
          }).catch((error)=>{
               this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al obtener la información';
              this.$refs.modalAlert.open();
          });
      },
      onSubmit(event) {
          event.preventDefault();
          this.$refs.modalLoading.open();
          
          if (this.id != null) {
              axios.post(tools.url("/api/admin/myvacancies/"+this.id),this.form).then((response)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'success';
                  this.modal.msg = 'Vacante modificada correctamente';
                  this.$refs.modalAlert.open();
                  var self = this;
                  setTimeout(function(){ 
                    self.$refs.modalAlert.close();
                    self.$router.push('/cuenta-empresa/editar-vacantes') 
                  }, 1000);

              }).catch((error)=>{
                this.$refs.modalLoading.close();
                   this.modal.icon = 'error';
                  this.modal.msg = 'Ocurrio un error al guardar la información';
                  this.$refs.modalAlert.open();

              });
          }
          else{
            axios.post(tools.url("/api/admin/myvacancies"),this.form).then((response)=>{
                this.$refs.modalLoading.close();
                this.modal.icon = 'success';
                this.modal.msg = 'Vacante agregada correctamente';
                this.$refs.modalAlert.open();
                this.form = {};
                this.form.tipo_puesto = null;
                this.form.areas_id = null;
                this.form.tipo_sueldo = null;
                this.form.periodo = null;
                this.form.genero = null;
                this.form.nivel_estudios = null;
                this.form.estado_id = null;
                this.form.ciudad_id = null;
                var self = this;
                  setTimeout(function(){ 
                    self.$refs.modalAlert.close();
                    self.$router.push('/cuenta-empresa/editar-vacantes') 
                  }, 1000);
                
                
            }).catch((error)=>{
              this.$refs.modalLoading.close();
                 this.modal.icon = 'error';
                this.modal.msg = 'Ocurrio un error al guardar la información';
                this.$refs.modalAlert.open();

            });
          }
      },
      getCategories(){
          axios.get(tools.url("/categoriesFront"))
          .then((response)=>{
              this.areasOpcs = response.data;
          }).catch((error)=>{
            
          });
      },
      getStatesOpcs(){
        axios.get(tools.url("/states")).then((response)=>{
            this.statesOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getTownsOpcs(state_id){
        axios.get(tools.url("/cities/"+state_id)).then((response)=>{
            this.townsOpcs = response.data;
          }).catch((error)=>{
          });
      },
      getHabilidadesOpcs(){
          axios.get(tools.url("/abilitiesFront")).then((response)=>{
              this.habilidadesOpcs=response.data;
          }).catch((error)=>{
          });
      },
  },
  mounted(){
      this.getCategories();
      this.getStatesOpcs();
      this.getHabilidadesOpcs();
      if(this.$route.params.id){
        this.id=this.$route.params.id;
        this.getData();
      }
  },

  components: {
    'editor': Editor,modalavisoComponent,modalterminosComponent

  },
}
</script>
